import { render } from "./j-button.vue?vue&type=template&id=5c61d155&scoped=true"
import script from "./j-button.vue?vue&type=script&lang=js"
export * from "./j-button.vue?vue&type=script&lang=js"

import "./j-button.vue?vue&type=style&index=0&id=5c61d155&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c61d155"]])

export default __exports__